<h1><a href="/admin-home">Admin</a> - Revenue by Month</h1>

<section>
  <p>{{loading}}</p>
  <mat-form-field>
    <mat-label>Search</mat-label>    
    <input matInput [(ngModel)]="searchText" (keyup)="applyFilter($event)"/>
    @if(searchText) {
      <button matSuffix mat-icon-button aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>  
  <div class="mat-elevation-z8 report-table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
        <td mat-cell *matCellDef="let row"> {{row.year}}</td>
      </ng-container>

      <ng-container matColumnDef="month">
        <th mat-header-cell *matHeaderCellDef> Month </th>
        <td mat-cell *matCellDef="let row"> {{row.month}}</td>
      </ng-container>

      <ng-container matColumnDef="revenue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Revenue </th>
        <td mat-cell *matCellDef="let row"> {{row.revenue | currency:'USD':'symbol':'1.2-2'}} </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons>
    </mat-paginator>
  </div>
  <br>
</section>

<!-- <section>
  <p>{{loading}}</p>
  <table class="data">
    <thead><tr><td>Month</td><td>Revenue</td></tr></thead>
    <tbody>
      @for (row of report; track row) {
        <tr>
          <td>{{row.year}}-{{row.month}}</td><td class="number">${{row.revenue.toFixed(2)}}</td>
        </tr>
      }
    </tbody>
  </table>
</section> -->
